export default __webpack_public_path__ + "static/media/Projects@32.9191bcce.svg";